export enum PreviewPlatform {
  DesktopWeb = 'desktopWeb',
  Mobile = 'mobile',
  MobileWeb = 'mobileWeb',
}
